import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import { ThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import React from 'react';
import Logo from '../Logo/Logo';
import './TopNavBar.scss';

const topBarTheme = {
    colorPrimary: 'white',
};

export default function TopNavBar() {
    return (
        <div className="navbar-block">
            <ThemeProvider theme={topBarTheme}>
                <AppBar position="static" className="inner-block">
                    <Toolbar>
                        <Logo />
                        <div className="btn--logout">
                            <Button
                                onClick={() => {
                                    window.location.href = '/';
                                }}
                            >
                                Log out
                            </Button>
                        </div>
                    </Toolbar>
                </AppBar>
            </ThemeProvider>
        </div>
    );
}
